<template>
    <div class="conversation-wrapper new-conversation">
        <section class="w-100">
            <div class="conversation-header px-3 py-2 d-flex jusitfy-content-center align-items-center">
                <div class="me-1 d-block d-md-none">
                    <a href="javascript:void(0);" @click="routeBacktoConnect"><i class="fas fa-chevron-left"></i></a>
                </div>
                <b class="me-1 ps-2 ps-md-3">To: </b
                ><TagsInput
                    class="w-100"
                    :getData="getUsersList"
                    :tags="users"
                    v-on:updateTags="updateTags"
                    placeholder="Start Typing a Name"
                    :is-focus="true"
                    :is-for-messaging="true"
                    :show-pill="false"
                    classes="w-100 form-group pt-2 mt-1"
                    focusOnInput="true"
                    tabindex="1"
                />
            </div>
            <div class="d-flex w-100 align-items-baseline group-name" v-if="users?.length > 1">
                <b class="me-1 ps-3" style="white-space: nowrap"
                    >Group Name
                    <a
                        tabindex="0"
                        href="javascript:void(0);"
                        role="button"
                        v-custom-popover="{ content: groupNameTooltip, className: 'info-popup' }"
                    >
                        <i class="fas fa-info-circle text-primary ms-2"></i>
                    </a>
                    :
                </b>
                <div class="form-group w-100">
                    <input
                        type="text"
                        class="form-control border-0"
                        :value="newChatTitle"
                        @change="updateTitle($event.target.value)"
                        placeholder="Enter Group Name (Optional)"
                        maxlength="250"
                        v-alphanumeric-dash-space-only
                        tabindex="2"
                    />
                </div>
            </div>
        </section>
        <section class="conversation-body">
            <!-- DO NOT DELETE THIS SECTION -->
        </section>
        <footer class="conversation-input">
            <ChatSummerEditor :key="`new-chat-editor`" :isNewConversation="true" />
        </footer>
    </div>
</template>

<script lang="ts" src="./NewConversation.ts"></script>

<style>
.group-name {
    height: 3.85rem;
}
</style>
